/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import styled from 'styled-components';

// TODO: use values from theme
export const ResetPasswordResponse = styled('div')`
  align-items: center;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2rem;
  width: 38.75rem;
`;

export const Container = styled('div')`
  background: #fff;
  display: flex;
  flex-direction: column;
  margin-top: 1.809rem;
  min-height: 15.125rem;
  padding: 2.538rem 1.938rem;
`;

export const TextContent = styled('p')`
  flex: 1;
  font-size: 0.875rem;
`;

export const Buttons = styled('div')`
  display: flex;
  justify-content: space-between;
`;

export const Subtitle = styled('h2')`
  font-size: 1rem;
  font-height: 600;
  margin-bottom: 1.25rem;
`;
